var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouare3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 26.6465V34.9028C38.8148 34.9272 37.6296 34.8703 36.4444 34.9028C35.9423 34.9191 35.2345 35.1466 34.7654 34.8703V26.6546H39.9999V26.6465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8807 5.55884C28.4115 6.02204 26.4115 6.60713 25.6872 6.8428C23.7942 7.44414 21.9671 7.84233 20.0411 8.28928C19.9506 8.31366 19.9012 8.23239 19.9259 8.40305C20.4856 9.08566 21.0617 9.76827 21.5473 10.4996C22.4444 11.8649 23.0041 13.3601 23.9177 14.7172C25.5062 17.0657 27.7037 19.1704 30.3374 20.3406C31.4732 20.8444 32.9136 20.9257 32.7243 22.5916C32.5926 23.7861 31.6708 24.2575 30.5432 23.9893C27.0288 23.136 23.5555 19.9424 21.4897 17.1144C21.4156 17.0251 21.3251 17.0088 21.2099 17.0007C20.716 16.96 19.0864 17.3664 18.5103 17.5045C15.9918 18.114 12.6749 19.2679 11.7284 21.9171C11.4897 22.5835 11.572 23.3717 10.856 23.7536C9.93415 24.2493 8.63374 23.6805 8.31275 22.7053C7.99176 21.7302 8.6502 20.1862 9.14403 19.3654C10.5185 17.0819 13.1605 15.7411 15.6132 14.8797C16.0247 14.7334 16.6255 14.6359 16.9959 14.4734C17.07 14.4409 17.1193 14.4897 17.0946 14.3434C17.07 14.2296 16.6667 13.6283 16.5679 13.4739C15.8354 12.3931 14.8807 11.4179 13.893 10.5646C13.4979 10.4184 13.0617 10.5971 12.6831 10.6053C10.3704 10.6622 8.11522 10.1096 6.10699 8.99627C4.87242 8.31366 3.58847 7.40351 4.58436 5.84326C5.62962 4.20175 7.16872 5.81076 8.32098 6.34709C9.18518 6.75341 10.3292 7.11096 11.2839 7.20035C11.6214 7.23286 13.1934 7.28162 13.3992 7.12722C13.6379 6.95657 13.8683 6.43648 14.2963 6.16019C15.2593 5.53446 18.2304 5.29067 19.5391 5.01438C21.1605 4.67307 22.7737 4.24238 24.3539 3.74667C25.1276 3.50288 27.3169 2.56836 27.9259 2.56836C29.3498 2.56836 29.8189 4.62431 28.8724 5.55071L28.8807 5.55884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20576 26.2646L5.23457 34.5941H0V26.2646H8.20576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7736 0C16.6337 0 16.5514 5.72092 12.7736 5.72905C8.99581 5.73717 8.95466 0 12.7736 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8559 20.7949C37.8847 20.6893 37.9588 22.3389 36.9135 22.3308C35.9588 22.3227 35.8847 20.9005 36.8559 20.7949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7118 24.5739C38.0822 24.5252 38.3209 24.9803 38.0493 25.2159C37.4896 25.7116 37.1028 24.6552 37.7118 24.5739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7489 23.8502C34.4032 24.1915 33.8271 23.6308 34.255 23.322C34.683 23.0132 35.0122 23.5902 34.7489 23.8502Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouare3);
export default __webpack_public_path__ + "static/media/youare3.7b793d177ec9610850ca38ca0eb76f47.svg";
export { ForwardRef as ReactComponent };